module.exports = __webpack_public_path__ + "media/images/delivery-df8b703c.svg";